<!-- @format -->
<template>
    <svg
        class="s3-close-svg"
        xmlns="http://www.w3.org/2000/svg"
        :width="size"
        :height="size"
        viewBox="0 0 17.949 17.949"
    >
        <g transform="translate(-955.173 -797.774)">
            <line class="a" y1="13.706" x2="13.706" transform="translate(957.294 799.896)" />
            <line class="a" x2="13.706" y2="13.706" transform="translate(957.294 799.896)" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 's3-close-svg',

    props: {
        size: {
            type: Number,
            default: 17.949,
        },
    },
};
</script>

<style>
.s3-close-svg .a {
    fill: none;
    stroke: var(--main-vivid-raspberry-base) /*svg theme update */;
    stroke-linecap: round;
    stroke-width: 3px;
}
</style>
